<div class="row mt-2 flex-nowrap" [class.scrollx]="isMobile" style="margin: 0px;">
  <div *ngFor="let empresaDoGrupo of empresas" class="mb-3 col-auto col-empresa" #secaoCategoria style="position: relative;"
       [class.ecommerce]="true">

    <div #circulo class="circle" (click)="abraCardapio(circulo, empresaDoGrupo)">
      <img src="/images/empresa/{{empresaDoGrupo.empresa.logo}}"/>

      <div class="div_label_empresa">
        <div class="label_empresa">{{empresaDoGrupo.empresa.nome}}</div>
      </div>
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="enable-background:new -580 439 577.9 194;"
           xml:space="preserve">
        <circle cx="50" cy="50" r="40" />
      </svg>
    </div>
  </div>
</div>
